import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const TheoremsModule = () => (
  <DMModuleSubtopic
    title="Theorems in Graph Theory"
    videos={[
        "https://www.youtube.com/embed/RiyqIiKqPEQ"
        
    ]}
    takeaways={[
      
      {text:" If there are any other theorems, don’t forget to learn them."},
      {text:" Prefer to learn the theorems from your class notes."},
      {
        text:"1",
        image:"/dm_41.png"
      },
      {
        text:"with Ex",
        image:"/dm_42.png"
      },
       {
        text:"2",
        image:"/dm_43.png"
      },
       {
        text:"3",
        image:"/dm_44.png"
      },
      {
        text:"4",
        image:"/dm_45.png"
      },
      {image:"/dm_46.png"},
      {image:"/dm_47.png"},

    ]}
    questions={[
        {text:"Verify whether the complete graph with 5 vertices is planar or non planar"},
        {text:"Prove that every connected simple planar graph G contains a vertex of degree less than 6 "},
        {text:"Prove that a connected graph G has a Euler circuit if and only if all vertices of G are of even degree"},
        {text:"In any graph show that the number of vertices with odd degree is even"},
        {text:"Prove that δ ≤ [2∈/ν] ≤ Δ , where δ and Δ are minimum and maximum degree vertices, ν is total number of vertices and ∈ is the total number of edges in G"},
        {text:"Show that a simple graph with n vertices and k components can have atmost (n-k)(n-k+1)/2 edges"},



        


    ]}
    exampleVideos={[]}
  />
);

export default TheoremsModule;
